module.exports = __webpack_public_path__ + "img/frost_wyrm_small.952973ef.png";